// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".options-list .v-list-item[data-v-2169ee06]{min-height:32px;padding:0 10px}.options-list .v-list-item__title[data-v-2169ee06]{cursor:pointer;font-size:10px}.options-drop-down[data-v-2169ee06]{box-shadow:none;margin-top:12px;position:absolute}.dots-horizontal[data-v-2169ee06]{position:absolute;right:12px;top:11px;transition:.3s ease}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
